/**
 * 	(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 	CONFIDENTIAL / 社外秘
 * 	無断開示・無断複製禁止
 */
/*
 * メインリストヘッダ
 * 共通部品
 */
<template>
	<tr class="tr-th-control row-head">
		<slot name="right-heade" ></slot>
		<th v-for="item in r_items" 
			:class="headerClassName(item)" 
			@click="onBtnSort(item)"
			:colspan="getCols(item)"
			:rowspan="getRows(item)"
			>
			<span class="th-header-text" v-html="item.name"></span>
			<!-- ソートアイコン -->
			<span
				v-if="item.id != 0 && !r_is_sort_disable"
				class="th-header-sort"
				:class="createSortIconClassName(item)">
			</span>
			<span v-if="item.require">
				<font class="text-red"> {{item.require}} </font>
			</span>
			<span v-if="item.slot">
				<slot :name="item.slot"></slot>
			</span>
		</th>
		<slot name="left-heade" ></slot>
	</tr>
</template>
<script>
export default {
		mixins: [
		],
		props:{
			r_nowsortid:Number,
			r_items:Array,
			/*[
				 	//! ソートアイテム定義
					{	
						id: 1,						//!< ソートID	※0:ソート無効
						name: 	"表示テキスト",		//!< 表示名
						class:	"クラス名",			//!< クラス名
						rows:1,						//!< for 段組み
						cols:1,						//!< for 段組み
					}
				]
			*/
			r_slot_name:"",
			r_is_sort_disable:false,
		},
		data: function (){
			//! 表示用に段組みして格納
			return {
			};
		},
		created:function(){
			$('[data-toggle="tooltip"]').tooltip()
		},
		methods: {
			/*
			* 詳細画面表示用データを更新
			*/
			onBtnSort:function( item ) {
				if(this.r_is_sort_disable)return;
				if(item.id != 0){
					if(Math.abs(this.r_nowsortid) == item.id )
					{
						this.$emit("event_sort",this.r_nowsortid*-1);
					}
					else{
						this.$emit("event_sort",item.id);
					}
				}
			},
			//! ソートアイコンのクラス名を生成
			headerClassName:function( item ) {
				var name = item.class;
				if( item.id != 0 ){
					name += ' sort-header';
				}
				return name;
			},
			//! ソートアイコンのクラス名を生成
			createSortIconClassName(item){
				var name = "glyphicon glyphicon-sort";
				if(this.r_nowsortid == item.id){
					name += ' glyphicon-sort-by-attributes';
				}
				else if(this.r_nowsortid == (item.id*-1)){
					name += ' glyphicon-sort-by-attributes-alt';
				}
				return name;
			},
			getCols:function(item){
				if(item && item["cols"])return Number(item["cols"]);
				return 1;
			},
			getRows:function(item){
				if(item && item["rows"])return Number(item["rows"]);
				return 1;
			},
		},
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/parts_com/listHeader.vue